import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

const useDeleteStandardizationProject = () => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(async (id) => {
    return await axios.delete(`/standardization/${id}`);
  });

  const deleteProject = (projectId, { onSuccess, onSettled }) => {
    mutate(projectId, {
      onSuccess: (res) => {
        if (!res.data) {
          toast.error(`The project can not be deleted!`);
          return;
        }

        queryClient.invalidateQueries('standardizationProjects', { exact: true });

        toast.success(`Successfully Deleted! `);

        onSuccess && onSuccess(projectId);
      },
      onError: (err) => {
        toast.error(err.message || 'Error! Try again later.');
      },
      onSettled: () => onSettled && onSettled(),
    });
  };

  return {
    deleteProject,
    isLoading,
  };
};

export default useDeleteStandardizationProject;
